export const getManyProductsByManySkus = (skus: string[]) => {
  if (!skus || !(skus instanceof Array)) {
    throw new Error(`Must provide handles to queryGetManyProductsBySKU; provided: ${typeof skus === 'object' ? JSON.stringify(skus) : skus} `)
  }

  const variables = {
    query: skus
      .filter(Boolean)
      .map((sku) => `variants.sku:"${sku.replace(/"/g, '\\"')}"`)
      .join(' OR '),
    first: 100
  }
  const query = `
    query searchProducts($query: String!, $first: Int) {
      search(query:$query, types: PRODUCT, first: $first) {
        nodes {
          ... on Product {
            id
            title
            handle
            tags
            productBiline: metafield(namespace: "custom", key: "product_bi_line") {
              value
            }
            variants (first: 100) {
              nodes {
                id
                availableForSale
                sku
                price {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  `

  return { query, variables }
}

export const getManyProductsByManyHandles = (handles: string[]) => {
  if (!handles || !(handles instanceof Array)) {
    throw new Error(`Must provide handles to queryGetManyProductsByHandle; provided: ${typeof handles === 'object' ? JSON.stringify(handles) : handles} `)
  }

  const variables = {
    query: handles
      .filter(Boolean)
      .map((handle) => `handle:${handle.replace(/[^a-zA-Z0-9_-]/g, '')}`)
      .join(' OR '),
    first: 100
  }
  const query = `
    query searchProducts($query: String!, $first: Int) {
      search(query:$query, types: PRODUCT, first: $first) {
        nodes {
          ... on Product {
            id
            title
            handle
            tags
            productBiline: metafield(namespace: "custom", key: "product_bi_line") {
              value
            }
            variants (first: 100) {
              nodes {
                id
                availableForSale
                sku
                price {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  `

  return { query, variables }
}
